import { api } from '../../plugins/api';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
  return {
    renseignementsGeneraux: {
      firstName: "",
      lastName: "",
      dateDeNaissance: null,
      sexe: null,
      genre: null,
      titreDePreference: null,
      pni: null,
      citoyennetes: [],
      autresCitoyennetes: "",
      paysDeNaissance: null,
      autrePays: "",
      adresse: "",
      ville: "",
      provinceOuEtatSiApplicable: null,
      pays: null,
      codePostal: "",
      telephoneResidence: "",
      cellulaire: "",
      courriel: "",
    }
  }
}

const state = getDefaultState()

const getters = {
  getRenseignementsGeneraux: (state) => { return state.renseignementsGeneraux },
}

const mutations = {
  setRenseignementsGeneraux(state, dto) {
    state.renseignementsGeneraux = { ...dto }
    //state.renseignementsGeneraux.sexe = { ...dto.sexe }
  },
  setSexe(state, value) {
    state.renseignementsGeneraux.sexe = value;
  },
  setGenre(state, value) {
    state.renseignementsGeneraux.genre = value
  },
  setTitreDePreference(state, value) {
    state.renseignementsGeneraux.titreDePreference = value
  },
  setPni(state, value) {
    state.renseignementsGeneraux.pni = value
  },
  updateAddressFromCanadaPost(state, payload) {
    if (payload.address) {
      state.renseignementsGeneraux.adresse = payload.address.Line1;
      state.renseignementsGeneraux.codePostal = payload.address.PostalCode;
      state.renseignementsGeneraux.ville = payload.address.City;
      if (payload.listeProvinces != null && payload.listeProvinces.length > 0) {
        state.renseignementsGeneraux.provinceOuEtatSiApplicable = payload.address.ProvinceName == null ? null : payload.listeProvinces.find(p => p.lang00.toLowerCase() == payload.address.ProvinceName.toLowerCase() || (p.code != null && p.code.toLowerCase() == payload.address.ProvinceCode.toLowerCase()));
      } else {
        state.renseignementsGeneraux.provinceOuEtatSiApplicable = null;
      }
      if (payload.listePays != null && payload.listePays.length > 0) {
        state.renseignementsGeneraux.pays = payload.address.CountryName == null ? null : payload.listePays.find(p => p.lang00.toLowerCase() == payload.address.CountryName.toLowerCase() || (p.code != null && p.code.toLowerCase() == payload.address.CountryIso2.toLowerCase()));
      } else {
        state.renseignementsGeneraux.pays = null;
      }
    }
  },
  updateAddressFromCanadaPostWithManualEntry(state, payload) {
    if (payload.address) {
      state.renseignementsGeneraux.adresse = payload.address;
    }
  },
  resetState(state) {
    Object.assign(state, getDefaultState())
  }
}

const actions = {
  async updateRenseignementsGenerauxFromAdmission({ commit }, dto) {
    const response = await api.put(`demandesadmissions`, dto);
    commit('setRenseignementsGeneraux', response.data ? response.data : {});
  },
  async updateRenseignementsGenerauxFromInscription({ commit }, dto) {
    const response = await api.put(`demandesinscriptions`, dto);
    commit('setRenseignementsGeneraux', response.data ? response.data : {});
  },
  async updateRenseignementsGenerauxFromContact({ commit }, dto) {
    const response = await api.put(`contacts/renseignements-generaux`, dto);
  },
  async getRenseignementsGenerauxFromAdmission({ commit }, encryptedId) {
    const response = await api.get(`demandesadmissions/` + encryptedId);
    commit('setRenseignementsGeneraux', response.data ? response.data : {});
  },
  async getRenseignementsGenerauxFromInscription({ commit }, encryptedId) {
    const response = await api.get(`demandesinscriptions/` + encryptedId);
    commit('setRenseignementsGeneraux', response.data ? response.data : {});
  },
  async getRenseignementsGenerauxFromContact({ commit }, encryptedId) {
    const response = await api.get(`contacts/` + encryptedId + `/renseignements-generaux`);
    commit('setRenseignementsGeneraux', response.data ? response.data : {});
  },
  resetModuleState({ commit }) {
    commit('resetState')
  },
}

export default ({
  namespaced: true,
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
})